fragment OrderItemProductVariationPrintFragment on OrderItemProductVariationPrint {
    id

    order_item_product_variation_id

    print_assignment_id
    print_cost_id
    print_handling_charge_id

    printAssignment {
        ...PrintAssignmentFragment
    }

    printCost {
        ...PrintCostFragment
    }

    printHandlingCharge {
        ...PrintHandlingChargeFragment
    }

    print_cost_code
    print_cost_key
    print_cost_color

    print_cost_info
    print_cost_type

    print_assignment_location

    print_handling_charge_code

    pcs_imprint_cost
    total_imprint_cost

    pcs_start_cost
    total_start_cost

    pcs_print_handling_charge
    total_print_handling_charge

    discount

    created_at
    updated_at
}